import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginPageComponent} from './pages/login/login-page.component';
import {HomePageComponent} from './pages/home/home-page.component';
import {AuthGuardService} from './services/auth-guard.service';
import {TestsPageComponent} from './pages/tests/tests/tests-page.component';
import {TestQuestionsPageComponent} from './pages/tests/test-questions/test-questions-page.component';
import {TestPageComponent} from './pages/tests/test/test-page.component';
import {TestExecutionPageComponent} from './pages/test-execution/test-execution-page.component';
import {TestResultsPageComponent} from './pages/tests/test-results/test-results-page.component';
import {TestResultPageComponent} from './pages/tests/test-result/test-result-page.component';
import {UsersPageComponent} from './pages/users/users/users-page.component';
import {UserPageComponent} from './pages/users/user/user-page.component';
import {MePageComponent} from './pages/me/me-page.component';

const routes: Routes = [
  {
    path: '', component: HomePageComponent,
    pathMatch: 'full', canActivate: [AuthGuardService],
  },
  {
    path: 'login', component: LoginPageComponent,
  },
  {
    path: 'tests/:testId/questions', component: TestQuestionsPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'tests/:testId/results/:resultId', component: TestResultPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'tests/:testId/results', component: TestResultsPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'tests/:testId', component: TestPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'tests', component: TestsPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'users/:userId', component: UserPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'users', component: UsersPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'me', component: MePageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'tex/:urlCode', component: TestExecutionPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
